import { AddProjectFormComponent } from './add-project-form';
import { AssignDepartmentToProjectComponent } from './assign-department';
import { ExportComponent } from './export';

export * from './add-project-form';
export * from './assign-department';
export * from './export';

export const ProjectOrganisms = [
    AddProjectFormComponent,
    AssignDepartmentToProjectComponent,
    ExportComponent
]